import React from "react"
import { Divider, ImageList, ImageListItem } from "@mui/material"
import { scroll } from "../scroll animation.js"

import { body1, body2, body3, body4, body5, body6, body7, body8 } from "./content/robotics-2.js"
import leader_follower from "./images/leader-follower.png"
import rosmaster from "./images/rosmaster.png"
import robot_paths from "./images/robot_paths.png"
import robots_distance from "./images/robots_distance.png"
import robot_paths_odom from "./images/robot_paths_odom.png"
import robots_distance_odom from "./images/robots_distance_odom.png"
import leader_follower_demo from "./images/leader_follower_demo.mp4"

const Robotics2project = () => {
    return <div>
        <div className="projects-container">
            <div className="pleft">
                <div className="glyph ptitle no-highlight pointer" data-text="leader-follower robots" id="leader-follower-robots" onClick={scroll}>leader-follower robots</div>
                <div className="glyph psubtitle">class project, robotics ii - spring 2026</div>
                <Divider variant="middle" flexItem className="pdivider" style={{backgroundColor: "#fec780"}}></Divider>
                <div className="geometric pbody">{body1}<br/><br/>I'm a big fan of robots
                </div>
            </div>
            <div className="pright pimg-container"><img className="pimg" src={leader_follower} alt="a homemade theremin in a cardboard box being played" controls></img></div>
        </div>

        <div className="gap"></div>

        <div className="projects-container">
            <div className="pleft pimg-container"><img className="pimg" src={rosmaster} alt="a Yahboom ROSMASTER X3" controls></img></div>
            <div className="pright geometric pbody">
                {body2}
                <br/><br/>
                {body3}
                <br/><br/>
                {body4}
            </div>
        </div>

        <div className="gap"></div>

        <div className="projects-container">
            <div className="pleft geometric pbody">
                {body5}
            </div>
            <div className="pright">
                <ImageList>
                    <ImageListItem><img src={robot_paths} alt="graph of the robots' positions" /></ImageListItem>
                    <ImageListItem><img src={robots_distance} alt="graph of the distances between the robots over time" /></ImageListItem>
                </ImageList>
            </div>
        </div>

        <div className="gap"></div>

        <div className="projects-container">
            <div className="pleft">
                <ImageList>
                    <ImageListItem><img src={robot_paths_odom} alt="graph of the robots' positions" /></ImageListItem>
                    <ImageListItem><img src={robots_distance_odom} alt="graph of the distances between the robots over time" /></ImageListItem>
                </ImageList>
            </div>
            <div className="pright geometric pbody">
                {body6}
            </div>
        </div>

        <div className="gap"></div>

        <div className="projects-container">
            <div className="pleft geometric pbody">
                {body7}
                <br/><br/>
                {body8}
                <br/><br/>
                <span>The code for this project is available <a className="no-link-styling link" href="https://github.com/ZachNobles/RoboticsII_Final_Project" aria-label="GitHub repo">at this repository</a></span>
            </div>
            <div className="pright pimg-container">
                <video className="pimg" src={leader_follower_demo} alt="demo of the leader-follower robots" controls></video>
            </div>
        </div>

    </div>
}


export default Robotics2project;